// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.certificado-card[data-v-70d76482] {\n  border-right: 6px solid transparent;\n}\n.border-success[data-v-70d76482] {\n  border-right-color: #48c774; /* Bulma success */\n}\n.border-info[data-v-70d76482] {\n  border-right-color: #3298dc;\n}\n.border-danger[data-v-70d76482] {\n  border-right-color: #f14668;\n}\n.border-dark[data-v-70d76482] {\n  border-right-color: #363636;\n}\n.border-light[data-v-70d76482] {\n  border-right-color: #dbdbdb;\n}\n", ""]);
// Exports
module.exports = exports;
